// import { ReactNode } from 'react';

import { 
    BodyXLMedium,
    BodySmallRegular
} from '@/components/typography';

interface FeatureCardProps {
    title: string;
    description: string;
    image?: string;
    // children?: ReactNode;
    className?: string;
    txtWrapperClassname?: string;
    imageClassName?: string;
}

export function FeatureCard({ title, description, image, className = '', txtWrapperClassname = '', imageClassName = '' }: FeatureCardProps) {
    return (
        <div className={`flex flex-col items-start relative justify-end p-4 h-[152px] lg:min-h-60 lg:h-auto bg-gradient-to-br from-white/20 to-white/5 rounded-3xl shadow-[0px_0.9585345387458801px_23.963363647460938px_0px_rgba(69,42,124,0.10)] border-2 border-white/10 backdrop-blur-xl overflow-hidden ${className}`}>            
            
            {/* Gradient backgrounds */}
            <div className="w-full h-[522.99px] left-[601.09px] lg:left-[601.09px] top-[-128.12px] absolute bg-primary/60 blur-[156.83px] z-0" />
            <div className="w-80 h-[522.99px] left-[601.09px] lg:left-[601.09px] top-[-128.12px] absolute bg-primary/20 blur-[156.83px] z-30" />
            <div className="w-full h-full left-0 top-[-244.19px] lg:top-[-244.19px] absolute bg-cyan-400/60 rounded-full blur-[156.83px] z-10" />
            
            {/* Content */}
            <div className={`relatiave z-20 max-w-[336px] left-4 lg:left-6 top-4 lg:top-[148px] inline-flex flex-col justify-end items-start gap-3 ${txtWrapperClassname}`}>
                <BodyXLMedium className="w-[80%] text-white">
                    {title}
                </BodyXLMedium>
                <BodySmallRegular className="w-48 lg:w-auto lg:max-w-none text-white/60">
                    {description}
                </BodySmallRegular>
            </div>
            
            {/* Image or custom content */}
            {image && (
                <div className='w-full h-full top-0 left-0 absolute flex justify-end items-end'>
                    <img
                        className={`relative ${imageClassName}`} 
                        src={image} 
                        alt={title}
                    />
                </div>
            )}
        </div>
    );
}
